import { Phone, MessageCircle, X } from "lucide-react";
import { useEffect, useState } from "react";
import { COMPANY } from "@/lib/company";

export function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 600);
    return () => clearTimeout(t);
  }, []);

  if (!mounted) return null;

  return (
    <div className="fixed bottom-[calc(1.25rem+env(safe-area-inset-bottom))] right-4 z-[60] flex max-w-[calc(100vw-2rem)] flex-col items-end gap-3 md:bottom-6 md:right-6">
      {/* Expandable labels */}
      <div
        className={`flex flex-col items-end gap-3 transition-all duration-300 ${
          open ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0"
        }`}
      >
        {/* Phone card */}
        <a
          href={`tel:${COMPANY.phoneIntl}`}
          className="group flex max-w-full items-center gap-3 rounded-full border border-gold/40 bg-card px-4 py-3 shadow-xl ring-1 ring-black/5 transition-all hover:scale-[1.02] hover:shadow-2xl"
          data-cta="floating-call"
          aria-label={`โทร ${COMPANY.phone}`}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full text-white" style={{ background: "var(--gradient-gold)" }}>
            <Phone className="h-5 w-5" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">โทรปรึกษาฟรี</span>
            <span className="text-sm font-extrabold text-primary">{COMPANY.phone}</span>
          </span>
        </a>

        {/* LINE card */}
        <a
          href={`https://line.me/R/ti/p/${COMPANY.lineId}`}
          target="_blank"
          rel="noopener"
          className="group flex max-w-full items-center gap-3 rounded-full border border-emerald-200 bg-card px-4 py-3 shadow-xl ring-1 ring-black/5 transition-all hover:scale-[1.02] hover:shadow-2xl"
          data-cta="floating-line"
          aria-label={`LINE ${COMPANY.lineId}`}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#06C755] text-white">
            <MessageCircle className="h-5 w-5" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">แชท LINE</span>
            <span className="text-sm font-extrabold text-[#06C755]">{COMPANY.lineId}</span>
          </span>
        </a>
      </div>

      {/* Main toggle FAB */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={open ? "ปิดเมนูติดต่อ" : "เปิดเมนูติดต่อ"}
        className="relative isolate flex h-14 w-14 items-center justify-center rounded-full text-white shadow-2xl ring-4 ring-white/60 transition-transform hover:scale-105 md:h-16 md:w-16"
        style={{ background: "var(--gradient-gold)" }}
      >
        {/* Pulse ring */}
        {!open && (
          <>
            <span className="absolute inset-0 animate-ping rounded-full bg-gold/50" aria-hidden />
            <span className="absolute -right-1 -top-1 flex h-3.5 w-3.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex h-3.5 w-3.5 rounded-full bg-emerald-500 ring-2 ring-white" />
            </span>
          </>
        )}
        {open ? <X className="h-6 w-6" /> : <Phone className="h-6 w-6 md:h-7 md:w-7" />}
      </button>

      {/* Helper bubble - shows briefly on first mount */}
      {!open && (
        <div className="absolute -top-2 right-20 hidden translate-x-0 rounded-xl bg-primary px-3 py-1.5 text-xs font-bold text-primary-foreground shadow-lg md:block">
          ปรึกษาฟรี 24/7
          <span className="absolute -right-1 top-1/2 -translate-y-1/2 rotate-45 border-y-4 border-l-4 border-y-transparent border-l-primary" />
        </div>
      )}
    </div>
  );
}
